// @flow
import * as React from 'react';
import dateIconFile from '../../../assets/calendar.svg';
import text from "../../../services/localization/text";

const DateIcon:React.Node = <span className={"date-icon-span"}><img src={dateIconFile} alt={text.date} /></span>;

export default DateIcon;
